import request from "../../request";
import { getDiplomaci } from "../../firebaseReshaper";
// const strKategori = [
//   { name: "Struktura Kryesore", struktura: [7, 3, 12] },
//   {
//     name: "Komisione",
//     struktura: [12, 3, 3, 3, 12]
//   },
//   {
//     name: "Grupe parlamentare",
//     struktura: [12, 3, 3, 3, 12]
//   }
// ];
const getStrkWithId = (id, str) => {
  let strTmp = {};
  str.map(str1 => {
    if (str1.id === id) {
      strTmp = str1;
    }
    return true;
  });
  return strTmp;
};
export const getAllStrukturat = async () => {
  let response = await request({}, "/api/struktura/GetAllStrukturat", "index");

  return response;
};
export const getStrukturaById = async id => {
  let response = await request(
    {},
    "/api/struktura/GetStrukturaDetailsByID/" + id,
    "index"
  );

  return response;
};
export const getStrukturaMeKategori = async () => {
  let struktura = await getAllStrukturat();
  let strKategori = await getDiplomaci();
  let reshaped = strKategori.map(kat => {
    kat.struktura = Array.from(kat.struktura).map(str => {
      return getStrkWithId(str.id ? str.id : str, struktura);
    });
    return kat;
  });
  return reshaped;
};
